import { StyleSheet } from 'react-native';

import { Input, colors, spacing } from '@pletly/ui';

export const TermsInput = ({ text }: { text: string }) => (
	<Input
		fullWidth
		multiline
		numberOfLines={20}
		disabled
		textStyle={styles.text}
		style={styles.textInput}
		value={text}
	/>
);

const styles = StyleSheet.create({
	text: { color: colors.black700, paddingVertical: spacing(2) },
	textInput: { borderWidth: 0, backgroundColor: colors.white },
});
